import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-view-location',
  templateUrl: './view-location.component.html',
  styleUrls: ['./view-location.component.css']
})
export class ViewLocationComponent implements OnInit {
  public orgID;
  public tableShow: boolean = false;
  public locationData:any=[];
  public customTableData:any=[];
  public tableCols = [
    { key: '#', display: '#' },
    { key: 'title', display: 'Title', width: '130px' },
    { key: 'lat', display: 'Latitude' },
    { key: 'lng', display: 'Longitude' },
    { key: 'name', display: 'Location name',headerConfig:{ isDefault: true} },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      },
    }
  ]
  public locationInformation:any = [];
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }
  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  constructor(
    public api: ApiService,
    public router: Router,
    public location: Location,
    public storage: StorageService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    ) { 
      this.route.paramMap.subscribe(params => {
        this.orgID = params.get('orgID');
      });}

  ngOnInit(): void {
    this.getLocationList();
  }
  getLocationList(page = 1, limit = 10, search?){
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      page: page,
      limit: limit,
    };
    if (search) obj['title'] = search;
    this.api.transportManagerLocationList(obj).then((res: any) => {
        if (res.status == 'success') {
            if (res.data.length>0){
              this.processTableData(res.data);
              this.processPagination(res, obj);
            }else{
              this.locationInformation = [];
            }
        }  
    }).catch((err) => {
        console.log(err);
    });
  }
  processTableData(data) {
    this.tableShow = false;
    this.locationInformation = data.map((loc) => {
      let obj = {
        title: loc.title,
        lat:loc.location.lat,
        lng: loc.location.lng,
        name: loc.location.name,
        locationID: loc.locationID,
        orgID: loc.orgID,
        createdAt: loc.createdAt,
        status: loc.status,
      }
      return obj;
    });
    setTimeout(() => { this.tableShow = true; }, 100);
  }
  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getLocationList(data.page, data.limit, this.searchInputValue);
  }
  onSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getLocationList(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getLocationList(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }
  onActionHandler(e: any) {
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/location/edit-location', e.data.locationID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteLocation(e);
        }
      });
    }
  }
  deleteLocation(e){
    const obj = {
      orgID: e.data.orgID,
      locationID: e.data.locationID,
    };
    this.api.transportManagerLocationDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data == undefined || res.data == '') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.tableShow = true;
          this.getLocationList(1, this.paginationData.limit, this.searchInputValue);
        }
      } else {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
